import styled, { css } from 'styled-components';

export const commonInputStyles = css`
  input[type='password'],
  input[type='text'],
  input[type='number'],
  input[type='search'] {
    width: 180px !important;
    height: initial !important;
  }
`;

export const commonFieldsetsStyles = css`
  .collapsible-filter-builder-body form {
    gap: 0px;
    > div > div {
      gap: 5px;
    }
    fieldset {
      width: 160px;
      max-width: 160px;
    }
  }
`;

export const commonButtonStyles = css`
  fieldset + .oneface-icon-button,
  .button-add-wrapper button {
    width: 20px !important;
    height: 20px !important;
    padding: 4px;
  }
`;

export const commonDatePickerStyles = css`
  .oneface-date-picker button {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  [data-testid='date-range'] fieldset {
    margin-top: -4px;
  }
`;

export const commonSectionTitleStyles = css`
  .section-title {
    font:
      600 16px/22px Open Sans,
      sans-serif;
  }
`;

export const commonFieldContentStyles = css`
  .field-content svg {
    font-size: 16px;
  }
`;

export const commonLoadingStyles = css`
  .loading-next-page {
    padding: 24px 0;
  }
`;

export const commonEmptyStateStyles = css`
  [data-testid='emptystate-data'] {
    background: transparent !important;
  }
`;

export const commonListContentStyles = css`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-top: 5px;
  opacity: 1;
`;

export const commonFilterStyles = css`
  div[data-testid='filter-builder'] {
    padding: 5px 15px;
    max-height: 110px;
    box-shadow: none;
  }
`;

export const commonCollapsibleFilterStyles = css`
  .collapsible-filter-builder-body {
    background-color: #fff;
    border: none;
    box-shadow: 0px 5px 6px #0000003d;
    opacity: 1;
    z-index: 1;
    > button {
      width: 100%;
    }
    .section-body {
      padding: 0px !important;
    }
  }
`;

export const commonContainerStyles = css`
  display: flex;
  flex-direction: column;
  height: auto;
`;

export const commonTableStyles = css`
  flex: 1;
  min-height: 0;
  padding: 5px 5px 0 5px;
  height: 100%;

  .tabulator-table {
    user-select: none;
  }
`;
  
export const BaseListContainer = styled.div`
  ${commonContainerStyles}
  ${commonCollapsibleFilterStyles}
  ${commonFilterStyles}
  ${commonFieldsetsStyles}
  ${commonInputStyles}
  ${commonButtonStyles}
  ${commonDatePickerStyles}
  ${commonSectionTitleStyles}
  ${commonFieldContentStyles}
  ${commonLoadingStyles}
  ${commonEmptyStateStyles}
`;
